import React, { useState } from 'react';
import { Select, Button, Modal, message, Row, Col, List } from 'antd';
import { leaseInformationTemplate } from './LeaseInformation';
import { permitsAndLicensesTemplate } from './PermitsAndLicenses';
import { PropertyManagementAndDirectoryTemplate } from './PropertyManagementAndDirectoryTemplate';
import Editor from '../Editor';
import { CheckOutlined } from '@ant-design/icons';

const templates = [
	{ title: 'Lease Information', template: leaseInformationTemplate },
	{ title: 'Permits and Licenses', template: permitsAndLicensesTemplate },
	{ title: 'Property Management and Directory', template: PropertyManagementAndDirectoryTemplate },
];

const TemplateSelector = ({ onSelectTemplate, onCancel }) => {
	const [selectedTemplate, setSelectedTemplate] = useState(templates[0].title);
	const [loading, setLoading] = useState(false);

	const handleSelectTemplate = (template) => {
		setLoading(true);
		onSelectTemplate({
			title: selectedTemplate,
			blocks: templates.find((template) => template.title === selectedTemplate).template,
		});
	};

	return (
		<div style={{ margin: '0 auto', marginLeft: 16 }}>
			<Modal
				title="Select a Template"
				visible
				onCancel={onCancel}
				footer={[
					<Button key="cancel" onClick={onCancel}>
						Cancel
					</Button>,
					<Button
						key="apply"
						type="primary"
						disabled={!selectedTemplate}
						onClick={handleSelectTemplate}
						loading={loading}
					>
						Use Template
					</Button>,
				]}
				confirmLoading={loading}
				width={'80vw'}
				bodyStyle={{ height: '80vh', overflowY: 'auto' }}
			>
				<Row className="bg-white">
					<Col span={8} style={{ borderRight: '1px solid #E5E5E5' }}>
						<div className="flex flex-col">
							<List
								dataSource={templates}
								renderItem={(template, index) => (
									<List.Item
										className={`cursor-pointer bg-neutral-1 px-6 py-1 hover:bg-neutral-2 ${
											selectedTemplate === template.title ? 'bg-neutral-3' : ''
										}`}
										key={index}
										onClick={() => setSelectedTemplate(template.title)}
									>
										<div className="flex w-full flex-row justify-between px-6 py-1">
											<div className="bodyregular">{template.title}</div>
											{selectedTemplate === template.title ? (
												<CheckOutlined className="stroke-black" />
											) : null}
										</div>
									</List.Item>
								)}
							/>
						</div>
					</Col>
					<Col span={16}>
						<Editor
							key={selectedTemplate}
							document={{
								blocks: templates.find((template) => template.title === selectedTemplate).template,
								title: selectedTemplate,
							}}
							editable={false}
							updateDocument={(blocks) => {}}
							showToolbar={false}
						/>
					</Col>
				</Row>
			</Modal>
		</div>
	);
};

export default TemplateSelector;
